import { render, staticRenderFns } from "./FoodSearch.vue?vue&type=template&id=552a6262&"
import script from "./FoodSearch.vue?vue&type=script&lang=js&"
export * from "./FoodSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports